import { render, staticRenderFns } from "./BaseHeaderSearch.vue?vue&type=template&id=bed5a9ac&scoped=true&"
import script from "./BaseHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderSearch.vue?vue&type=style&index=0&id=bed5a9ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed5a9ac",
  null
  
)

export default component.exports